const API_BASE = process.env.REACT_APP_API_URL || '';

async function apiPost(endpoint, data) {
  const res = await fetch(`${API_BASE}${endpoint}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  const json = await res.json();
  if (!res.ok) throw json;
  return json;
}

async function apiGet(endpoint) {
  const res = await fetch(`${API_BASE}${endpoint}`);
  const json = await res.json();
  if (!res.ok) throw json;
  return json;
}

export const submitEvaluationRequest = (data) => apiPost('/evaluations/new', data);
export const submitContactForm       = (data) => apiPost('/contact', data);
export const lookupEvaluation        = (num)  => apiGet(`/evaluations/lookup/${num}`);
export const lookupContact           = (num)  => apiGet(`/contact/lookup/${num}`);
